import AddIcon from '@mui/icons-material/Add';
import { Button, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import useRoles from 'common/hooks/useRoles';
import { VendorProvider, useVendorContext } from './context/VendorContext';
import { StockReceivingDraftProvider } from './context/StockReceivingDraftContext';
import AddStockDialog from './components/AddStockDialog';
import StockManagementFilterButton from './components/StockManagementFilterButton';
import StockManagementFilterStatusBar from './components/StockManagementFilterStatusBar';
import StockManagementTable from './components/StockManagementTable';

const StockManagementContent = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const hasAccess = useRoles();
  const { loadInitial } = useVendorContext();

  useEffect(() => {
    document.title = 'Stock Management - SmartOS';
  }, []);

  // Prefetch the vendor list on page load (only for users who can create receipts) so the vendor
  // dropdown opens instantly instead of showing a loading spinner on first click. loadInitial is
  // guarded by the provider, so this never double-fetches with the Autocomplete's onOpen.
  useEffect(() => {
    if (hasAccess.createReceivingOrder) loadInitial();
  }, [hasAccess.createReceivingOrder, loadInitial]);

  return (
    <>
      <Grid container sx={{ px: 3, pb: 2 }} direction='column'>
        <Grid item container alignItems='center' sx={{ py: 1.5 }}>
          <Grid item sx={{ flexGrow: 1 }}>
            <StockManagementFilterStatusBar />
          </Grid>
          <Grid item sx={{ display: 'flex', gap: 1 }}>
            {hasAccess.createReceivingOrder && (
              <Button
                variant='contained'
                startIcon={<AddIcon />}
                onClick={() => setDialogOpen(true)}
              >
                New Stock
              </Button>
            )}
            <StockManagementFilterButton />
          </Grid>
        </Grid>

        <Grid item container sx={{ mt: 1 }}>
          <StockManagementTable />
        </Grid>
      </Grid>

      <AddStockDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

const StockManagement = () => (
  <VendorProvider>
    <StockReceivingDraftProvider>
      <StockManagementContent />
    </StockReceivingDraftProvider>
  </VendorProvider>
);

export default StockManagement;
